export default "__VITE_ASSET__6144d186__"